import { useAppContext } from '../context/useAppContext';
import UserType from '../models/Account/UserType';

const useUserTypes = (): UserType[] => {
  const {
    state: { user },
  } = useAppContext();

  if (user && user.types && user.types.length > 0) return user.types;

  return [UserType.BaseUser];
};

export default useUserTypes;
